import { Container } from "@mui/material";
import { useEffect } from "react";

const StayTuned = () => {
  useEffect(() => {
    document.body.classList.add("bgBlue");
    return () => {
      document.body.classList.remove("bgBlue");
    };
  }, []);
  return (
    <section className="stayTuned">
      <Container fixed>
        <h1>
          <span>Stay Tuned</span> CodeWeek is coming and the fun begins!
        </h1>
        <p>
          The EU CodeWeek 2025 is scheduled to start on 11 October 2025. Do
          check back at the mentioned time to get access to the resourced.
        </p>
      </Container>
    </section>
  );
};
export default StayTuned;
